<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="65"
    fill="none"
    viewBox="0 0 65 65"
  >
    <path
      stroke="currentColor"
      stroke-width="1.5"
      d="m23.221 23.027 19.335 19.335M23.221 42.362l19.335-19.335"
    />
    <rect
      width="64"
      height="64"
      x=".5"
      y=".5"
      stroke="currentColor"
      rx="32"
    />
  </svg>
</template>

<script setup>
defineOptions({ name: 'IconCloseRound' })
</script>
